/**
 * ARK Drops RS — Story-of-ARK band video: play only while in viewport and tab visible.
 */
(function () {
  const ROOT_SELECTOR = '[data-ark-story-of-ark]';
  const VIDEO_SELECTOR = '[data-ark-story-of-ark-video]';
  const FRAME_SELECTOR = '.ark-story-of-ark__frame';

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch {
      return false;
    }
  }

  function initRoot(root) {
    if (root.dataset.arkStoryOfArkInit === 'true') return;
    root.dataset.arkStoryOfArkInit = 'true';

    const video = root.querySelector(VIDEO_SELECTOR);
    const frame = root.querySelector(FRAME_SELECTOR);
    if (!video || !frame) return;

    const state = {
      inViewport: false,
      tabVisible: typeof document === 'undefined' || !document.hidden,
      reducedMotion: prefersReducedMotion(),
    };

    function shouldPlay() {
      return state.inViewport && state.tabVisible && !state.reducedMotion;
    }

    function syncPlayback() {
      if (shouldPlay()) {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } else {
        video.pause();
      }
    }

    function onIntersect(entries) {
      const entry = entries.find(function (e) {
        return e.target === frame;
      });
      if (!entry) return;
      state.inViewport = entry.isIntersecting;
      syncPlayback();
    }

    function onVisibility() {
      state.tabVisible = !document.hidden;
      syncPlayback();
    }

    function onMotionChange(event) {
      state.reducedMotion = event.matches;
      syncPlayback();
    }

    const observer = new IntersectionObserver(onIntersect, {
      threshold: 0,
    });
    observer.observe(frame);

    if (typeof document !== 'undefined' && 'visibilityState' in document) {
      document.addEventListener('visibilitychange', onVisibility);
    }

    let motionMq;
    try {
      motionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
      motionMq.addEventListener('change', onMotionChange);
    } catch {
      /* matchMedia unsupported */
    }

    root._arkStoryOfArkCleanup = function () {
      observer.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
      if (motionMq) {
        motionMq.removeEventListener('change', onMotionChange);
      }
    };

    syncPlayback();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (typeof root._arkStoryOfArkCleanup === 'function') {
        root._arkStoryOfArkCleanup();
      }
      delete root.dataset.arkStoryOfArkInit;
    });
  });
})();
